import styled from "styled-components";

export const FooterStyled = styled.div`

position: relative;
    color: white;
    /* background-color: #ad85e7; */
    display: flex;
    width: 100%;

`;
export const H5HeadingStyled = styled.h5`

        position: relative;
    color: white;
    /* background-color: #ad85e7; */
    justify-content: center;
    display: flex;
    align-items: end;
    width: 100%;
    padding: 10px;

    @media only screen and (max-width: 1280px) {
      position: relative;
    color: white;
    /* background-color: #ad85e7; */
    justify-content: center;
    display: flex;
    align-items: end;
    /* width: 100%; */
    padding: 0px;
  
}
`
export const ContainerFooter = styled.div`

position: absolute;
  display: flex;
  /* flex-wrap: wrap; */
  justify-content: space-evenly;
  width: 98%;
  /* top: -0px; */
  /* height: 100%; */
  /* margin-block: 2rem; */
  /* gap: 20rem; */
  padding-top: 20px;
  text-decoration: none;
  color: white;
  /* background-color: rgb(87, 50, 50); */
  
  @media only screen and (max-width: 1280px) {
  position: absolute;
  display: flex;
  justify-content: space-evenly;
  text-decoration: none;
  color: black;
  width: 100%;
  /* gap: 5rem; */
  

}
`

